import { useState } from "react";
import { format } from "date-fns";
import { ArrowDown, ArrowUp } from "lucide-react";

import { Button } from "components/ui/Button";
import { Checkbox as CustomCheckbox } from "components/ui/Checkbox";

import checkboxIcon from "../../../../../ResultsTable/checkbox-icon.svg";
import styles from "./ResultDetails.module.css";

const formatValueWithLineBreaks = (value) => {
  if (!value) return "-";
  const parts = value.split("\\.br\\");

  if (parts.length === 1) return value;
  return (
    <span style={{ display: "flex", flexDirection: "column" }}>
      {parts.map((part, index) => (
        <span key={index}>{part.trim()}</span>
      ))}
    </span>
  );
};

const ResultItem = ({ value, warning }) => {
  return (
    <span
      className={`${styles.boldItem} ${warning === "low" ? styles.low : ""} ${
        warning === "high" ? styles.high : ""
      } ${value === "Open" ? styles.open : ""}`}
    >
      {formatValueWithLineBreaks(value)}
      {warning === "low" && (
        <ArrowDown
          style={{ width: "20px", height: "20px", strokeWidth: "2" }}
        />
      )}
      {warning === "high" && (
        <ArrowUp style={{ width: "20px", height: "20px", strokeWidth: "2" }} />
      )}
    </span>
  );
};

export const ResultDetails = ({ items = [], addItemsToForm }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const hasItems = items.length > 0;

  const handleImport = () => {
    const res = items
      .filter((item) => selectedItems.includes(item.id))
      .map((item) => ({
        title: item.testName,
        date: format(new Date(item.date), "dd-MM-yyyy"),
        result: item.value,
        unit: item?.units || "",
      }));

    addItemsToForm(res);
  };

  return (
    <>
      <div className={styles.vaccineDetailsWrapper}>
        <div className={styles.tablewrapper}>
          <div className={styles.table}>
            <div className={styles.tableHeader}>
              <div>
                <img
                  className={styles.menuIcon}
                  alt="checkbox"
                  src={checkboxIcon}
                />
              </div>
              <p id="results-table-reference-range">Name</p>

              <p id="results-table-test">Date</p>
              <p id="results-table-recent-results">Result</p>
            </div>
            {selectedItems?.length > 0 && hasItems && (
              <div className={styles.tableSelectedItemsWrapper}>
                <div>
                  <p>{selectedItems?.length} items selected</p>
                  <button onClick={() => setSelectedItems([])}>Clear</button>
                </div>
              </div>
            )}
            {hasItems ? (
              <ul className={styles.tableItems}>
                {items.map((item) => (
                  <li key={item.id} className={styles.tableItem}>
                    <CustomCheckbox
                      checked={selectedItems.includes(item.id)}
                      handleChange={(e) => {
                        if (e.target.checked) {
                          setSelectedItems([...selectedItems, item.id]);
                        } else {
                          setSelectedItems(
                            selectedItems.filter((id) => id !== item.id)
                          );
                        }
                      }}
                    />
                    <p aria-describedby="results-table-reference-range">
                      {item.testName}
                    </p>
                    <p>{item.date}</p>
                    <p>
                      <ResultItem
                        value={`${item.value} ${item?.units || ""}`}
                        warning={item.warning}
                      />
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={styles.emptyState}>
                <p className={styles.emptyStateTitle}>No results available</p>
                <p className={styles.emptyStateText}>
                  When results are ready they will appear in this list.
                </p>
              </div>
            )}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button disabled={!selectedItems.length} onClick={handleImport}>
            Import
          </Button>
        </div>
      </div>
    </>
  );
};
